import { Navigate } from "react-router-dom";
import { StorageGetItem } from "./StorageComp";
import Unauthorized from "./401";

export const authData = () => {
  const authData = StorageGetItem("bookAuthData");
  if (authData) {
    return JSON.parse(authData);
  } else {
    return null;
  }
}

export const isAuthenticate = () => {
  const authData = StorageGetItem("bookAuthData");
  if (authData) {
    return true;
  } else {
    return false;
  }
}

export const withAdminAuth = (WrappedComponent) => {
  return (props) => {
    if (typeof window !== "undefined") {
      const authData = StorageGetItem("bookAuthData");
      if (authData) {
        let authDataArr = JSON.parse(authData);
        let isPagePerm = false;
        props?.permissions?.map(i => {
          if (authDataArr?.permissions?.indexOf(i) > -1)
            isPagePerm = true;
          return null;
        });

        return (authDataArr?.user_type === 1 || isPagePerm) ? <WrappedComponent {...props} /> : <Unauthorized />;
      } else {
        return <Navigate to={'/sign-in'} />
      }
    }
    return null;
  };
};